import { Parser } from '../../Parse/Parser';
import { ParseNode } from '../../Parse/ParseNode';
import { ExprComp } from '../ExprComp';
import { ExprForm } from '../ExprForm';
import { Generic } from './Generic';
export var PctOfTotal;
(function (PctOfTotal) {
    PctOfTotal.Patterns = [
        {
            parsed: Parser.parse(`$0 / $1($2)`),
        },
    ];
    function matches(candidateNode) {
        for (const pattern of PctOfTotal.Patterns) {
            if (pattern.parsed.type === "FAILURE") {
                return new Error(`Could not compile percent of total pattern`);
            }
            const comp = ExprComp.capture(pattern.parsed.root, candidateNode);
            if (comp == null) {
                return false;
            }
            if (comp instanceof Error) {
                return comp;
            }
            if (comp.type === "SUCCESS") {
                return isMatchingComp(comp);
            }
        }
        return false;
    }
    PctOfTotal.matches = matches;
    function isMatchingComp(comp) {
        const { exprs: [expr1, totalFn, expr2], } = comp;
        if (!(expr1 && expr2 && totalFn)) {
            return false;
        }
        if (expr1.name !== expr2.name) {
            return false;
        }
        if (expr1.form !== expr2.form) {
            return false;
        }
        if (expr1.form !== ExprForm.Access && expr1.form !== ExprForm.Aggregate) {
            return false;
        }
        if (totalFn.root.type !== "CallExpression") {
            return false;
        }
        const using = ExprForm.TotalUsing.make(totalFn.root.callee);
        if (using === undefined) {
            return false;
        }
        return true;
    }
    function source(expr, using = ExprForm.TotalUsing.Total) {
        const target = ParseNode.toString(expr.root);
        switch (using) {
            case ExprForm.TotalUsing.Total:
                return `${target} / TOTAL(${target})`;
            case ExprForm.TotalUsing.Avg:
                return `${target} / WINDOW_AVG(${target})`;
            case ExprForm.TotalUsing.Max:
                return `${target} / WINDOW_MAX(${target})`;
            case ExprForm.TotalUsing.Min:
                return `${target} / WINDOW_MIN(${target})`;
            case ExprForm.TotalUsing.Sum:
                return `${target} / WINDOW_SUM(${target})`;
        }
    }
    PctOfTotal.source = source;
    let Parsed;
    (function (Parsed) {
        function make(root) {
            for (const pattern of PctOfTotal.Patterns) {
                if (pattern.parsed.type === "FAILURE") {
                    continue;
                }
                const comp = ExprComp.capture(pattern.parsed.root, root);
                if (comp == null) {
                    continue;
                }
                if (comp instanceof Error) {
                    continue;
                }
                if (comp.type === "FAILURE") {
                    continue;
                }
                if (isMatchingComp(comp)) {
                    const [expr, totalFn] = comp.exprs;
                    const form = ExprForm.PctOfTotal;
                    const state = "PARSED";
                    if (expr == null ||
                        (totalFn === null || totalFn === void 0 ? void 0 : totalFn.root.type) !== "CallExpression") {
                        continue;
                    }
                    const using = ExprForm.TotalUsing.make(totalFn.root.callee);
                    if (using === undefined) {
                        continue;
                    }
                    switch (expr.form) {
                        case ExprForm.Access:
                        case ExprForm.Aggregate: {
                            const { name } = expr;
                            return {
                                state,
                                root,
                                expr,
                                name,
                                form,
                                using,
                            };
                        }
                    }
                }
            }
            return Generic.Parsed.make(root);
        }
        Parsed.make = make;
    })(Parsed = PctOfTotal.Parsed || (PctOfTotal.Parsed = {}));
    let Compiled;
    (function (Compiled) {
        function make(parsed, expr, stage, data) {
            const { name } = expr;
            return {
                ...parsed,
                state: "COMPILED",
                expr,
                name,
                stage,
                data,
            };
        }
        Compiled.make = make;
    })(Compiled = PctOfTotal.Compiled || (PctOfTotal.Compiled = {}));
})(PctOfTotal || (PctOfTotal = {}));
